import * as React from 'react';

interface LoadingProps {
}

export class Loading extends React.Component<LoadingProps, {}> {
    public render() {
        return <div className="pf-loading lds-ripple">
            <div></div>
            <div></div>
        </div>;
    }
}
